import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';
import { BellSchedulesTable } from 'widgets/bell-schedules-table';

export const BellSchedulesPage = () => {
  const breadcrumbs = [
    homeBreadcrumbItem,
    {
      title: 'Расписание звонков',
      url: '',
    },
  ];

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
      }}
      documentTitle="Расписание звонков"
    >
      <BellSchedulesTable />
    </AppPage>
  );
};
